import { render, staticRenderFns } from "./data-download-list.html?vue&type=template&id=7ffec6e3&scoped=true&external"
import script from "./data-download-list.js?vue&type=script&lang=js&external"
export * from "./data-download-list.js?vue&type=script&lang=js&external"
import style0 from "./data-download-list.scss?vue&type=style&index=0&id=7ffec6e3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffec6e3",
  null
  
)

export default component.exports